import AppPanel from '../fw/AppPanel.react';
import React from 'react';
import PropTypes from 'prop-types';
import Relay from 'react-relay';
import {wrapNotFound} from '../app/NotFoundHandler.react';
import {defaultPageSize} from '../fw/PagingGrid.react';
import {FormattedMessage, IntlShape} from 'react-intl';

import types from '../../common/model-api/types';
import ChannelHeader from '../channels/ChannelHeader.react';
import DataSetListDetail from './DataSetListDetail.react';
import {getLastOrganisationId} from '../app/LastOrganisationId';
import { User } from '../../common/types/types';

interface DataSetListProps {
    relay: object;
    user: User;
}

class DataSetList extends React.Component<DataSetListProps> {

    typeName = 'dataSets';

    static propTypes = {
        relay: PropTypes.object.isRequired,
        user: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
    }

	// eslint-disable-next-line max-params
    renderLine = (content, column, item, url, columnMapping) => {
        if (item && item.storeInfo && item.storeInfo.hasAnyData) {
            return <strong>{content}</strong>;
        } else {
            return <i>{content}</i>;
        }
    };

    render() {
        const data = this.props.user.organisation.channel;
        let type = types[this.typeName];

        let title = data.channelDef.name;
        if (data.name) {
            title += ' - ' + data.name;
        }

        return (
            <AppPanel breadcrumbParams={[
                {type, data},
                {type: types['channels'], data: this.props.user.organisation.channel},
                {type: types['organisations'], data: this.props.user.organisation}]
            }
                  className="CachedData"
                  title={title}>
                <ChannelHeader data={data} organisation={this.props.user.organisation}>
                    <h3><FormattedMessage defaultMessage="Cached data:" id="application.connectedTitle" /> {title}</h3>
                </ChannelHeader>

                <DataSetListDetail
                    dataSets={data.dataSets}
                    sourceGroupDefs={data.channelDef.sourceGroupDefs}
                />


            </AppPanel>
        );
    }
}

export default Relay.createContainer(wrapNotFound(DataSetList, (props) => {
    return props.user.organisation && props.user.organisation.channel;
}), {
    initialVariables: {
        organisationId: '',
        channelId: '',
        first: defaultPageSize,
    },
    prepareVariables (variables) {
		if (!variables.organisationId) {
            variables.organisationId = getLastOrganisationId();
        }

        return variables;
    },
    fragments: {
        user: () => Relay.QL`
            fragment on User {
                organisation(id: $organisationId) {
                    id,
                    name,
                    featureFlags,
                    channel(id: $channelId) {
                        id,
                        realId,
                        organisation_id,
                        type,
                        cachingStatus,
                        confidential,
                        description,
                        name,
                        metadata,
                        channelDef {
                            id,
                            name,
                            description,
                            icon,
                            metadata,
                            urlFragment,
                            sourceGroupDefs(first: 100) {
                                edges {
                                    node {
                                        id,
                                        realId,
                                        name,
                                        priority,
                                        importance
                                    }
                                }
                            }
                        },
                        dataSets(first: 200) {
                            edges {
                                node {
                                    id,
                                    channel_id,
                                    storeInfo {
                                        id,
                                        status,
                                        hasAnyData,
                                    },
                                    organisation_id,
                                    channel {
                                        id,
                                        name
                                    },
                                    sourceDef {
                                        id,
                                        name,
                                        sourceGroupDef_id,
                                    },
                                    channelDef {
                                        id,
                                        name
                                    },
                                    entityDef {
                                        id,
                                        name
                                    }
                                }
                            },
                            pageInfo {
                                hasNextPage,
                                hasPreviousPage,
                                startCursor,
                                endCursor
                            }
                        },
                    }
                }
            }
        `,
    },
});
